<template>
  <s-task-list-layout
    :title="$t('PublicServant.Me.AL.DAFConfirmed')"
    back-u-r-l="/tasklist/trainingList"
  >
    <v-data-iterator
      :items="historyItems"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :loading="loading"
      hide-default-footer
    >
      <template v-slot:default="props">
        <!-- Show only on xsOnly -->
        <v-card
          v-for="(trainingTask) in props.items"
          :key="trainingTask.applicationFormDataId"
          flat
          color="white"
          class="mb-4"
        >
          <v-card-text>
            <div>
              {{ $t('TaskList.ConfirmationTime') }} : {{ trainingTask.completedTime }}
            </div>
            <p class="text-h6 text--primary">
              {{ $chPtObjData('chinTaskListTitle', trainingTask) }} <span class="primary--text">{{ $chPtObjData('staffChinName',trainingTask) }}</span>
            </p>
            <div>{{ $t('TrainingClient.HistoryTaskList.Ordering') }}: {{ trainingTask.appraiserOrder }}</div>
            <div>{{ $t('TrainingClient.Reason') }}: {{ $chPtObjData('appraiserReasonChinDesc',trainingTask) }}</div>
            <div>{{ $chPtObjData('chinTaskListDesc2', trainingTask) }}</div>
          </v-card-text>
          <v-card-actions>
            <div class="px-2">
              {{ $t('TaskList.FinalAction') }}:
              <!-- <template v-if="trainingTask.status === 'H' && trainingTask.action === 1"> -->
              <template v-if="trainingTask.status !== 'A' && trainingTask.action === 1">
                <span class="primary--text">{{ $t('TrainingClient.TaskList.Personal1.Agree.ed') }}</span>
              </template>

              <!-- <template v-if="trainingTask.status === 'H' && trainingTask.action === 3"> -->
              <template v-if="trainingTask.status !== 'A' && trainingTask.action === 3">
                <span class="error--text">{{ $t('Text.Cancel.ed') }}</span>
              </template>

              <!-- <span
                v-if="trainingTask.status === 'H' && trainingTask.action === 5"
                class="info--text"
              > -->
              <span
                v-if="trainingTask.status !== 'A' && trainingTask.action === 5"
                class="info--text"
              >
                <!-- end -->
                {{ $t('Training.TrainingCoordinator.ed') }}
              </span>
              <span
                v-if="trainingTask.status === 'T'"
                class="info--text"
              >{{ $t('TaskList.TransferToOthers.ed') }}</span>
            </div>
            <v-spacer />
            <!-- <v-btn
              icon
              @click="getPdfFromDms(task)"
            >
              <v-icon>
                mdi-file-document
              </v-icon>
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </template>

      <template v-slot:footer="props">
        <v-pagination
          v-if="props.pagination.pageCount"
          v-model="page"
          :length="props.pagination.pageCount"
          circle
        />
      </template>

      <template v-slot:no-data>
        <v-card
          flat
          class="mt-2 py-6"
        >
          <v-card-text class="text-body-1 black--text">
            {{ $t('PublicServant.NoData') }}
          </v-card-text>
        </v-card>
      </template>

      <template v-slot:no-results>
        <v-card
          flat
          class="mt-2 py-6"
        >
          <v-card-text class="text-body-1 black--text">
            {{ $t('PublicServant.NoData') }}
          </v-card-text>
        </v-card>
      </template>

      <template v-slot:loading>
        <v-skeleton-loader
          class="mb-6"
          type="list-item-avatar-three-line, divider, list-item-avatar-three-line"
        />
      </template>
    </v-data-iterator>
    <p class="px-4 text-caption grey--text">
      *{{ $t('Workflow.OnlyShowXMonths', {'0': '3'}) }}
    </p>
  </s-task-list-layout>
</template>

<script>

import STaskListLayout from './components/STaskListLayout'
// import SInternalProposal from './components/SInternalProposal'
// import STrainingList from './components/STrainingList'
import { mapState } from 'vuex'
import store from '../../store'
import { trainingTLModule } from '../../store/moduleName'

// We're dynamically registering the
// `taskList` store module. This has
// the benefit of only loading this
// module, if it's actually needed.
// Before registering the module, we're
// checking if it's already registered
// which can happen in combination with
// webpacks hot reloading.
if (!store.state[trainingTLModule]) store.registerModule(trainingTLModule)

export default {
  components: {
    STaskListLayout
    // SInternalProposal
  },
  data: function () {
    return {
      itemsPerPage: 10,
      page: 1,
      loading: false
    }
  },
  computed: {
    ...mapState({
      historyItems: state => state[trainingTLModule].historyItems
    })
  },
  created () {
    this.$store.dispatch(trainingTLModule + '/getHistoryItems')
  }
}
</script>
